const ReadyForPickupTriggerTypes = {
  AUTOMATIC: 'automatic',
  MANUAL: 'manual',
};

export default ReadyForPickupTriggerTypes;
